import { render, staticRenderFns } from "./three-columns.vue?vue&type=template&id=65b7bfa0&scoped=true&"
import script from "./three-columns.vue?vue&type=script&lang=js&"
export * from "./three-columns.vue?vue&type=script&lang=js&"
import style0 from "./three-columns.vue?vue&type=style&index=0&id=65b7bfa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b7bfa0",
  null
  
)

export default component.exports